<template>
  <div id="home" :style="{ height: cliHeight }">
    <div class="myHeader" style="height: 32%">
      <!-- <img style="width: 100%" src="../../assets/jpg/顶部.svg" alt /> -->
    </div>
    <!-- <div class="mySubHeaderCard" style="margin-top: -30px">
      <img style="width: 100%" src="../../assets/jpg/卡片.svg" alt />
    </div> -->

    <van-overlay :show="show" z-index="99999">
      <div class="wrapper" @click.stop>
        <div class="block">
          <h4 style="margin: 30px auto 10px; font-weight: bold">友情提示</h4>
          <p
            style="
              color: rgb(121, 121, 121);
              font-size: 16px;
              padding: 5px 10px;
              line-height: 26px;
              margin: -3px auto 18px;
              display: block;
              width: 85%;
            "
            id="errorText"
          ></p>
          <van-button
            size="large"
            block
            style="
              border-radius: 0px 0px 8px 8px;
              height: 52px;
              line-height: 52px;
            "
            @click="show = false"
          >
            <span>
              <p
                style="
                  color: rgb(103, 109, 143);
                  font-size: 18px;
                  margin-top: -10px;
                "
              >
                <b>我知道了</b>
              </p>
            </span>
          </van-button>
        </div>
      </div>
    </van-overlay>
    <div v-show="loginFlag" class="Mycontainer" id="Jurisdiction">
      <div class="mySubHeader" style="width: 100%">
        <!-- <img  style="width:90%;left: 5%;position: fixed;" src="../../assets/jpg/Group 98.svg" v-show="false" alt />
      <img  style="width:90%;left: 5%;position: fixed;" src="../../assets/jpg/Group 219.svg" v-show="false" alt />
      <img  style="width:90%;left: 5%;position: fixed;" src="../../assets/jpg/Group 220.svg" v-show="false" alt /> -->
        <div class="mySubHeaderButton">
          <div class="mySubHeaderButton2" @click="WarRoomHeader">作战室</div>
          <div class="mySubHeaderButton1" @click="PersonalPerformanceHeader">
            个人表现
          </div>
          <div class="mySubHeaderButton3" @click="treasureChestHeader">
            百宝箱
          </div>
        </div>
      </div>

      <van-grid
        :column-num="3"
        :border="false"
        v-show="personalPerformanceFlag"
      >
        <van-grid-item @click="SecBut8" id="Bonusview" style="display: block">
          <img src="../../assets/jpg/奖金查看icon.svg" />
          <p class="buttonTie">奖金查看</p>
        </van-grid-item>
        <van-grid-item
          @click="SecBut6"
          id="OurShinningMoment"
          style="display: block"
        >
          <img src="../../assets/jpg/OSM icon.svg" />
          <p class="buttonTie">Our Shining Moment</p>
        </van-grid-item>
        <van-grid-item @click="SecBut7" id="cdbestcoach" style="display: block">
          <img src="../../assets/jpg/cdbestcoach.png" />
          <p class="buttonTie">好教练报告</p>
        </van-grid-item>
      </van-grid>

      <van-grid :column-num="3" :border="false" v-show="warRoomMidFlag">
        <van-grid-item
          @click="butWarRoom"
          id="WarRoom"
          v-show="warRoomMidButtone1Flag"
        >
          <img src="../../assets/jpg/WARROOM icon new.svg" />
          <p class="buttonTie">War Room</p>
        </van-grid-item>
        <!-- <van-grid-item @click="but1" id="OperationsRoom" style="display: none">
          <img src="../../assets/jpg/1.png" />
          <p class="buttonTie">大促作战室</p>
        </van-grid-item> -->
        <van-grid-item
          @click="but2"
          id="SalesDaily"
          v-show="warRoomMidButtone2Flag"
        >
          <img src="../../assets/jpg/销售日报icon.svg" />
          <p class="buttonTie">Daily Sales</p>
        </van-grid-item>

        <van-grid-item
          @click="butSales2"
          id="SalesDaily"
          v-show="warRoomMidButtone2FlagSales2"
        >
          <img src="../../assets/jpg/销售日报icon.svg" />
          <p class="buttonTie">Daily Sales_HQ</p>
        </van-grid-item>

        <van-grid-item
          @click="but3"
          id="PosReport"
          v-show="warRoomMidButtone3Flag"
        >
          <img src="../../assets/jpg/ECPOS icon.svg" />
          <p class="buttonTie">EC - POS Report</p>
        </van-grid-item>

        <van-grid-item @click="but4" id="Radar" v-show="warRoomMidButtone4Flag">
          <img src="../../assets/jpg/行业雷达icon.svg" />
          <p class="buttonTie">行业雷达</p>
        </van-grid-item>
      </van-grid>

      <van-grid :column-num="3" :border="false" v-show="treasureChestFlag">
        <van-grid-item
          @click="SecBut3"
          id="Stock"
          v-show="treasureChestButton1Flag"
        >
          <img src="../../assets/jpg/库存查询icon.svg" />
          <p class="buttonTie">库存查询</p>
        </van-grid-item>
        <van-grid-item
          @click="SecBut4"
          id="BarCode"
          v-show="treasureChestButton2Flag"
        >
          <img src="../../assets/jpg/8.svg" />
          <p class="buttonTie">物码追踪</p>
        </van-grid-item>
        <van-grid-item @click="SecBut5" id="Order" style="display: block">
          <img src="../../assets/jpg/订单管家icon.svg" />
          <p class="buttonTie">订单管家</p>
        </van-grid-item>
        <van-grid-item @click="SecBut9" id="FileView" style="display: block">
          <img src="../../assets/jpg/文件查看icon.svg" />
          <p class="buttonTie">文件查看</p>
        </van-grid-item>
        <van-grid-item @click="SecBut10" id="FileView" style="display: block">
          <img src="../../assets/jpg/在线审批icon.svg" />
          <div
            class="permissionApprovalTips"
            v-show="permissionApprovalTipsFlag"
          >
            {{ approvalCount }}
          </div>
          <p class="buttonTie">eWorkflow审批</p>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="Myfooter">
      <p class="infoText">
        申请权限请在公众号中回复关键字“权限申请”，权限将于一个工作日后生效。
      </p>
      <!--<img src="../../assets/jpg/编组 3.png" alt style="margin: 0 auto 3px;" />-->
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import AES from "@/common/AES.js";
export default {
  data() {
    return {
      cliHeight: 0,
      loginFlag: false,
      show: false,
      errorMsg1:
        "申请权限请在公众号中回复关键字“权限申请”，权限将于一个工作日后生效。",
      errorMsg2:
        "申请权限请在公众号中回复关键字“权限申请”，权限将于一个工作日后生效。",
      errorMsg3:
        "申请权限请在公众号中回复关键字“权限申请”，权限将于一个工作日后生效。",
      loginTime: 0,
      personalPerformanceFlag: false,
      warRoomMidFlag: true,
      treasureChestFlag: false,
      warRoomMidButtone1Flag: false,
      warRoomMidButtone2Flag: false,

      warRoomMidButtone2FlagSales2: false,

      warRoomMidButtone3Flag: false,
      warRoomMidButtone4Flag: false,
      treasureChestButton1Flag: false,
      treasureChestButton2Flag: false,
      menuList: [],
      approvalCount: 0,
      approvalToken: "",
      permissionApprovalTipsFlag: false,
    };
  },
  methods: {
    test() {
      if (localStorage.getItem("loginFlag") == null) {
        localStorage.setItem("loginFlag", this.loginTime);
      } else {
        this.loginTime++;
        localStorage.setItem("loginFlag", this.loginTime);
      }
    },
    but1() {
      this.$router.push({ path: "/index" });
    },
    but2() {
      this.$router.push({ path: "/indexSec" });
    },

    butSales2() {
      this.$router.push({ path: "/indexSec2" });
    },

    but3() {
      this.$router.push({ path: "/indexThr" });
    },
    but4() {
      this.$router.push({ path: "/indexFor" });
    },
    but5() {
      this.$router.push({ path: "/indexFiv" });
    },
    butWarRoom() {
      this.$router.push({ path: "/IndexWar" });
    },
    but6() {
      this.$router.push({ path: "/indexSix" });
    },
    SecBut3() {
      window.location = "https://chinastockquery.kenvue.com.cn/front"; //QA chinastockquery-stg-qa.kenvue.com.cn, P chinastockquery.kenvue.com.cn
    },
    SecBut4() {
      window.location = "https://weika.weikayun.com/mobileLoginPage";
    },
    SecBut5() {
      window.location = "https://post.kenvue.com.cn/"; //QA post-qa.kenvue.com.cn , P post.kenvue.com.cn
    },
    SecBut6() {
      var name = JSON.parse(sessionStorage.getItem("userInfo")).name;
      var WWID = JSON.parse(sessionStorage.getItem("userInfo")).wwid;
      var timestamp = new Date().getTime();
      var nameEn = AES.encrypt(name, 1);
      var WWIDEn = AES.encrypt(WWID, 1);
      var ShinningMoment =
        "https://saleshub.kenvue.com.cn/#/osm/authentication?wwid=" +
        WWIDEn +
        "&jnjEmailPrefix=" +
        nameEn +
        "&timestamp=" +
        timestamp; //QA saleshub-qa.kenvue.com.cn， P https://saleshub.kenvue.com.cn/
      console.log(ShinningMoment);
      window.location = ShinningMoment;
    },
    SecBut7() {
      var name = JSON.parse(sessionStorage.getItem("userInfo")).name;
      var WWID = JSON.parse(sessionStorage.getItem("userInfo")).wwid;
      var timestamp = new Date().getTime();
      var nameEn = AES.encrypt(name, 5);
      var WWIDEn = AES.encrypt(WWID, 5);
      var cdbestcoach =
        "https://cdbestcoach.kenvue.com.cn/api/api/checkAccessFromPost?wwid=" +
        WWIDEn +
        "&jnjEmailPrefix=" +
        nameEn +
        "&timestamp=" +
        timestamp; //QA  QA cdbestcoach-qa.kenvue.com.cn, P cdbestcoach.kenvue.com.cn
      console.log(cdbestcoach);
      window.location = cdbestcoach;
    },
    SecBut8() {
      var name = JSON.parse(sessionStorage.getItem("userInfo")).name;
      var WWID = JSON.parse(sessionStorage.getItem("userInfo")).wwid;
      var timestamp = new Date().getTime();
      var nameEn = AES.encrypt(name, 3);
      var WWIDEn = AES.encrypt(WWID, 3);
      var BonusView =
        "https://saleshub.kenvue.com.cn/#/incentive/login?wwid=" + //QA saleshub-qa.kenvue.com.cn， P https://saleshub.kenvue.com.cn/
        WWIDEn +
        "&jnjEmailPrefix=" +
        nameEn +
        "&timestamp=" +
        timestamp +
        "&menu=incentive";
      console.log(BonusView);
      window.location = BonusView;
    },
    SecBut9() {
      var name = JSON.parse(sessionStorage.getItem("userInfo")).name;
      var WWID = JSON.parse(sessionStorage.getItem("userInfo")).wwid;
      var timestamp = new Date().getTime();
      var nameEn = AES.encrypt(name, 3);
      var WWIDEn = AES.encrypt(WWID, 3);
      var FilesView =
        "https://saleshub.kenvue.com.cn/#/incentive/login?wwid=" + //QA saleshub-qa.kenvue.com.cn, P saleshub.kenvue.com.cn
        WWIDEn +
        "&jnjEmailPrefix=" +
        nameEn +
        "&timestamp=" +
        timestamp +
        "&menu=files";
      console.log(FilesView);
      window.location = FilesView;
    },
    SecBut10() {
      var name = JSON.parse(sessionStorage.getItem("userInfo")).name;
      var WWID = JSON.parse(sessionStorage.getItem("userInfo")).wwid;
      var timestamp = new Date().getTime();
      var nameEn = AES.encryptDES(name);
      var FilesView =
        "https://eworkflow.kenvue.com/jnjhoco_mobile?userName=" + //QA   qa.eworkflow.johnsonsbaby.com.cn/jnjhoco_mobile_test
        nameEn +
        "&webToken=" +
        this.approvalToken;
      console.log(FilesView);
      if (this.approvalToken != null && this.approvalToken.length > 0) {
        window.location = FilesView;
      }
    },
    PersonalPerformanceHeader() {
      this.personalPerformanceFlag = true;
      this.warRoomMidFlag = false;
      this.treasureChestFlag = false;
      $(".mySubHeaderButton1").css({
        "border-radius": "30px",
        border: "1px solid #E38600",
        color: "#E38600",
        background: "white",
      });
      $(".mySubHeaderButton2").css({
        "border-radius": "none",
        border: "none",
        color: "#9B9B9B",
        background: "none",
      });
      $(".mySubHeaderButton3").css({
        "border-radius": "none",
        border: "none",
        color: "#9B9B9B",
        background: "none",
      });
    },
    WarRoomHeader() {
      this.personalPerformanceFlag = false;
      this.warRoomMidFlag = true;
      this.treasureChestFlag = false;
      $(".mySubHeaderButton1").css({
        "border-radius": "none",
        border: "none",
        color: "#9B9B9B",
        background: "none",
      });
      $(".mySubHeaderButton2").css({
        "border-radius": "30px",
        border: "1px solid #01B198",
        color: "#01B198",
        background: "white",
      });
      $(".mySubHeaderButton3").css({
        "border-radius": "none",
        border: "none",
        color: "#9B9B9B",
        background: "none",
      });
      this.menuList.forEach((element) => {
        if (element.menuName == "销售日报") {
          this.warRoomMidButtone2Flag = true;
        } else if (element.menuName == "EC Pos Report") {
          this.warRoomMidButtone3Flag = true;
        } else if (element.menuName == "雷达") {
          this.warRoomMidButtone4Flag = true;
        } else if (element.menuName == "War Room") {
          this.warRoomMidButtone1Flag = true;
        } else if (element.menuName == "销售日报2") {
          this.warRoomMidButtone2FlagSales2 = true;
        }
      });
    },
    treasureChestHeader() {
      this.personalPerformanceFlag = false;
      this.warRoomMidFlag = false;
      this.treasureChestFlag = true;
      $(".mySubHeaderButton1").css({
        "border-radius": "none",
        border: "none",
        color: "#9B9B9B",
        background: "none",
      });
      $(".mySubHeaderButton2").css({
        "border-radius": "none",
        border: "none",
        color: "#9B9B9B",
        background: "none",
      });
      $(".mySubHeaderButton3").css({
        "border-radius": "30px",
        border: "1px solid #8077E7",
        color: "#8077E7",
        background: "white",
      });
      this.initGetTaskCount();
      this.menuList.forEach((element) => {
        if (element.menuName == "库存查询") {
          this.treasureChestButton1Flag = true;
        } else if (element.menuName == "物码追踪") {
          this.treasureChestButton2Flag = false;
        }
      });
    },
    initMyHeight() {
      if (this.$route.path == "/home") {
        $(".cover-Blink-area").remove();
      }
      $(document).ready(function () {
        this.cliHeight = $(window).height();
        $("#home").height(this.cliHeight); //浏览器当前窗口可视区域高度
      });

      // $(window).resize(() => {
      //   this.cliHeight = $(window).height();
      //   $("#home").height(this.cliHeight); //浏览器当前窗口可视区域高度
      // });
    },
    initInfo() {
      this.$addr
        //.get("https://mbqa.kenvue.com.cn/mobile_api/auth/loginPing")
        .get("https://mb.kenvue.com.cn/mobile_api/auth/loginPing")
        //.get("https://mbqa.kenvue.com.cn/mobile_api/sso/loginTest?wwid=702307550")
        //.get("http://localhost:8081/mobile_api/sso/loginTest?wwid=702307550")
        .then((res) => {
          if (res.data.error == 0) {
            if (
              res.data.name == undefined &&
              res.data.unique_name == undefined
            ) {
              window.location =
              //"https://mbqa.kenvue.com.cn/mobile_api/auth/loginSendRedirect";
              "https://mb.kenvue.com.cn/mobile_api/auth/loginSendRedirect";
            } else {
              if (res.data.errorMsg != undefined) {
                //$("#Jurisdiction").css("display", "none");
                this.show = true;
                const userInfo = {};
                userInfo.wwid = res.data.unique_name;
                userInfo.name = res.data.name;
                sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
                if (res.data.errorMsg == "No access permission") {
                  $("#errorText").text(this.errorMsg1);
                } else if (res.data.errorMsg == "No access Role") {
                  $("#errorText").text(this.errorMsg2);
                } else if (res.data.errorMsg == "No access Menu") {
                  $("#errorText").text(this.errorMsg3);
                }
              } else {
                this.$toast("登陆成功");
                this.show = false;
                this.menuList = res.data.menuList;
                this.loginFlag = true;
                const userInfo = {};
                userInfo.wwid = res.data.unique_name;
                userInfo.name = res.data.name;
                sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
                this.WarRoomHeader();
              }
            }
          } else {
            this.loginFlag = false;
            this.$toast("登陆失败");
          }
        })
        .catch((error) => {
          this.$toast("服务器错误");
        });
    },
    initCookie() {
      if (document.cookie != null) {
        this.loginFlag = true;
      }
    },
    getAchving() {
      this.$addr
        .get("sellin/getTimeGone")
        .then((res) => {
          this.achVing = res.data.data;
          sessionStorage.setItem("achVing", this.achVing);
        })
        .catch((error) => {
          this.$toast("接受数据中");
        });
    },
    initGetTaskCount() {
      //获取待审批权限数量，token
      var name = JSON.parse(sessionStorage.getItem("userInfo")).name;
      var nameEn = AES.encryptDES(name);
      var nameDn = AES.decryptDES(nameEn);
      console.log("获取待审批权限数量");
      console.log("加密后的name：" + nameEn);
      console.log("解密后的name：" + nameDn);
      var that = this;
      var httpRequest = new XMLHttpRequest(); //第一步：建立所需的对象

      // eworkflow.johnsonsbaby.com.cn --> eworkflow.kenvue.com

      httpRequest.open(
        "GET",
        "https://eworkflow.kenvue.com/jnjhoco/admin/getMyTaskCount?userName=" + //QA https://qa.eworkflow.johnsonsbaby.com.cn/jnjhoco_test/admin/getMyTaskCount?userName=
          nameEn,
        true
      ); //第二步：打开连接  将请求参数写在url中  ps:"./Ptest.php?name=test&nameone=testone"
      httpRequest.send(); //第三步：发送请求  将请求参数写在URL中
      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState == 4 && httpRequest.status == 200) {
          var json = httpRequest.responseText; //获取到json字符串，还需解析
          var obj = JSON.parse(json);
          console.log(obj.code);
          if (obj.code == 200) {
            that.approvalToken = obj.data.webToken;
            that.approvalCount = obj.data.taskCount;
            console.log("webtoken：" + that.approvalToken);
            console.log("taskCount" + that.approvalCount);
            if (that.approvalCount > 0) {
              that.permissionApprovalTipsFlag = true;
            }
          }
        }
      };
    },
  },
  beforeMount() {
    this.initMyHeight();
    this.initCookie();
  },
  created() {
    this.initInfo();
    this.getAchving();
    //this.initGetTaskCount();
    // this.test()
  },
};
</script>
<style  scoped>
.myHeader {
  background-image: url(../../assets/jpg/顶部kenvue.png);
  background-position-y: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
.Myfooter {
  position: relative;
  text-align: center;
}
.infoText {
  position: absolute;
  top: -50px;
  font-family: "Helvetica", "AvenirNext-Regular";
  font-size: 13px;
  color: #3d3f49;
  left: 0;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 350px;
  min-height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
}
#home {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
  background-color: #117265;
}
/deep/ .van-grid-item__content--center {
  background-color: transparent;
}
.Mycontainer {
  /* margin-top: 20px; */
  flex: 1;
  /* min-height: 510px;
  max-height: 510px; */
  overflow-y: scroll;
  overflow-x: hidden;
  text-align: center;
  padding: 10px 0;
  background-color: #fff;
  border-radius: 20px 20px 0 0;
}
.Mycontainer img {
  display: block;
  width: 60px;
  height: 60px;
  margin-left: 15px;
  /* box-shadow: 0px 0px 7px 0; */
  border-radius: 20px;
}
.Mycontainer .buttonTie {
  margin: 5px 0 0 12px;
  font-family: "Helvetica", "AvenirNext-Regular";
  font-size: 10px;
  color: #3d3f49;
}
.mySubHeaderCard {
  height: 10px;
}
.mySubHeaderButton {
  height: 25px;
  width: 90%;
  margin: 0 auto;
  justify-content: space-between;
  display: flex;
  background: #efefef;
  border-radius: 30px;
  color: #9b9b9b;
}
.mySubHeaderButton1 {
  height: 25px;
  width: 30%;
  text-align: center;
  display: inline-block;
  border-radius: 30px;
  flex: 1;
  line-height: 25px;
  /*border: 1px solid #e38600;
  color: #e38600;
  background: white;*/
}
.mySubHeaderButton2 {
  height: 25px;
  width: 30%;
  text-align: center;
  display: inline-block;
  border-radius: 30px;
  flex: 1;
  line-height: 25px;
  /*border-radius: 30px;
  border: 1px solid #C81F3C;
  color: #C81F3C;
  background: white*/
}
.mySubHeaderButton3 {
  height: 25px;
  width: 30%;
  text-align: center;
  display: inline-block;
  border-radius: 30px;
  flex: 1;
  line-height: 25px;
}
.permissionApprovalTips {
  display: block;
  top: -65px;
  right: -20px;
  position: relative;
  background: red;
  font-size: 15px;
  border-radius: 50%;
  height: 22px;
  width: 22px;
  color: white;
  line-height: 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/button1.vue